import React from "react";

import { Tabs as TabsComponent } from "heat-next";

interface TabType {
    title: string;
    content: React.ReactNode;
}

interface TabsProps {
    data: TabType[];
    selectedTabIndex: number;
    setSelectedTabIndex: React.Dispatch<React.SetStateAction<number>>;
    stickyHeader?: boolean;
}

const Tabs: React.FC<TabsProps> = ({
    data,
    selectedTabIndex,
    setSelectedTabIndex,
    stickyHeader,
}) => {
    return (
        <TabsComponent
            data={data}
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={setSelectedTabIndex}
            stickyHeader={stickyHeader}
        />
    );
};

export default Tabs;
